import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { Section, Columns, Column, Title } from 'bulma-react';
import { Link } from 'react-router-dom';
import { TopController } from './TopController';
import { IconButton } from './common';
import db from '../data/tmp';
const data = {
  user: db.users.data[0],
  blogs: db.blogs.data
};

const style = {
  badge: {
    float: 'right',
    fontSize: '0.6rem',
    lineHeight: '1rem',
    marginBottom: '-1rem',
  },
  img: {
    shapeOutside: 'circle(1.5rem at 50% 30%)',
    width: '4rem',
    height: '4rem',
    marginTop: '-1.2rem',
    borderRadius: '3rem',
    backgroundColor: '#888',
    background: 'url()',
    backgroundSize: '4rem, cover',
    float: 'left',
    marginRight: '2.1rem',
  },
  title: {
    paddingLeft: '3.2rem',
    textTransform: 'uppercase',
    margin: 0,
  },
  surname: {
    textAlign: 'right',
    textTransform: 'uppercase',
    margin: 0,
    marginTop: '-0.5rem',
    marginBottom: '-0.2rem',
  },
  status: {
    // paddingLeft: '4.6rem',
    lineHeight: '1rem'
  }
};

class ProfileBanner extends Component {
  onStateChange = payload => this.props.stateCb(payload);
  render() {
    const { onClickEvent } = this.props;
    style.img.background = `url(${data.user.imageUrl})`;
    return (
      <Section profileBanner style={{
        paddingTop: '0.75rem',
        // backgroundColor: '#fee',
        textAlign: 'left',
      }}>
        <TopController stateCb={this.onStateChange} onClickEvent={onClickEvent}/>
        <div style={{
          width: '16rem',
          margin: 'auto',
        }}>
          {/* <div style={ style.badge }><FontAwesome name="star" /></div> */}
          <Title is-1 capitalize style={ style.title }
          >{ data.user.name }</Title>
          <Title is-4 style={ style.surname }
          >{ data.user.surname }</Title>
          <div style={ style.img } title={ data.user.name + 'image' } />
          <p className="pull-initial" style={ style.status }
          >{ data.user.status }</p>
          <div style={{ clear: 'both' }}/>
        </div>
      </Section>
    );
  }
}

export default ProfileBanner;




// WEBPACK FOOTER //
// ./src/components/ProfileBanner.js